import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem, TableFooter, TableRow, TableCell } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const QuotationBookReport = () => {

    const history = useHistory();

    const [openSidebar, setOpenSidebar] = useState(false);

    const [filterText, setFilterText] = useState("");

    const [data, setData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState(null);

    const [perPage, setPerPage] = useState(50);

    const [page, setPage] = useState(0);

    const [search, setSearch] = useState('');

    const [totalCount, setTotalCount] = useState(0);

    const currentDate = new Date();

    const sevenDaysAgo = new Date(currentDate);

    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);

    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);

    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);

    const [enquirySource, setEnquirySource] = useState([]);

    const [selectedState, setSelectedState] = useState();

    const [stateOptions, setStateOptions] = useState([]);

    const [selectedBrand, setSelectedBrand] = useState();

    const [brandOptions, setBrandOptions] = useState([]);

    const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);

    const [executiveOptions, setExecutiveOptions] = useState([]);

    const [sources, setSources] = useState([]);

    const [selectedSource, setSelectedSource] = useState();

    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const [snackbarMessage, setSnackbarMessage] = useState('');

 
    // Finance transfer selection is retained across pagination.
    const [selectedFinanceIds, setSelectedFinanceIds] = useState([]);
    const [financeDialogOpen, setFinanceDialogOpen] = useState(false);
    const [financeSubmitting, setFinanceSubmitting] = useState(false);
    const [financeError, setFinanceError] = useState('');
    const [financeFilters, setFinanceFilters] = useState({
        client_name: 'Tyger', state_id: '', start_date: '', end_date: ''
    });

    const [viewOpen, setViewOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    useEffect(() => {

        const fetchData = async () => {

            try {

                const response = await axios.get(`${API_BASE_URL}/webApi/sources`);

                const data = response.data.data;

                setSources(data.map(item => item.enquiry_from));

            } catch (error) {

                console.error('Error fetching data:', error);

            }

        };

        fetchData();

    }, []);

    const handleSelectChange = (event) => {

        setSelectedSource(event.target.value);

    };

    const handleView = (record) => {

        setSelectedRecord(record);

        setViewOpen(true);

    };

    const handleCloseView = () => {

        setViewOpen(false);

        setSelectedRecord(null);

    };

    useEffect(() => {

        const fetchDatabrand = async () => {

            try {

                const config = {

                    headers: {

                        'Content-Type': 'application/json',

                        'Accept': 'application/json',

                        'Authorization': `${token}`,

                    },

                    timeout: Infinity,

                };



                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);



                const statelist = response.data.data.map(item => ({

                    id: item.brand_id,

                    title: item.brand_name,

                }));



                setBrandOptions(statelist);



            } catch (error) {

                console.error('Error fetching state:', error);

            }
        };

        fetchDatabrand();

    }, []);

    useEffect(() => {

        const fetchDatastate = async () => {

            try {

                const config = {

                    headers: {

                        'Content-Type': 'application/json',

                        'Accept': 'application/json',

                        'Authorization': `${token}`,

                    },

                    timeout: Infinity,

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);

                const statelist = response.data.data.map(item => ({

                    id: item.state_id,

                    title: item.state_name,

                }));

                setStateOptions(statelist);

            } catch (error) {

                console.error('Error fetching state:', error);

            }

        };
        fetchDatastate();

    }, []);

    useEffect(() => {

        const fetchDatalist = async () => {

            try {

                const config = {

                    headers: {

                        'Content-Type': 'application/json',

                        'Accept': 'application/json',

                        'Authorization': `${token}`,

                    },

                    timeout: Infinity,
                };


                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);

                const mappedData = response.data.data.map(item => ({

                    id: item.admin_id,

                    title: item.username,

                }));

                setExecutiveOptions(mappedData);

            } catch (error) {

                console.error('Error fetching executives:', error);

            }

        };

        fetchDatalist();

    }, []);

    const handleExecutiveChange = (event) => {

        const selectedId = event.target.value;

        setSelectedExecutiveId(selectedId);

    };

    const handleStateChange = (event, newValue) => {

        setSelectedState(newValue);

    };

    const handleBrandChange = (event, newValue) => {

        setSelectedBrand(newValue);

    };

    const fetchData = async () => {

        setIsLoading(true);

        setError(null);

        try {

            const config = {

                headers: {

                    "Content-Type": "application/json",

                    "Accept": "application/json",

                    "Authorization": `${token}`,

                    "adminId": `${adminId}`,

                    "userLevel": `${userLevel}`,

                },

                timeout: Infinity,

            };



            const requestData = {

                brand_id: selectedBrand?.id || "",

                state_id: selectedState?.id || "",

                source: selectedSource || "",

                start_date: fromDate,

                end_date: toDate,

                page: page + 1,

                pagination: perPage,

                search: search,

            };
            const response = await axios.post(

                `${API_BASE_URL}/api/admin/v2/supplier-enquires-report`,

                requestData,

                config

            );
            const apiData = response.data.data;

            const mappedData = apiData.data.map((item) => ({

                id: item.id,

                fullName: item.full_name,

                mobile: item.mobile,

                state_name: item.state,

                city_name: item.city,

                taluka: item.taluka || "",

                enquiry_from: item.source,

                brand_name: item.brand?.brand_name || "",

                status:

                    item.enquiry?.clientapi_status?.name?.trim() ||

                    item.status ||

                    "",

                modelName: item.modelName,

                supplied_at: item.supplied_at,

                created_at: new Date(item.created_at).toLocaleString("en-IN", {

                    year: "numeric",

                    month: "short",

                    day: "2-digit",

                }),

                pincode: item.pincode || "",

                executive: "",

            }));

            setData(mappedData);

            setTotalCount(apiData.total);

            setSnackbarMessage(response.data.message[0]);

            setSnackbarOpen(true);



        } catch (error) {

            console.error(error);

            setError("Failed to fetch data");

        } finally {

            setIsLoading(false);

        }
    };


    const source = axios.CancelToken.source();

    const sourceRef = useRef(null);

    useEffect(() => {

        fetchData();

    }, [page, perPage]);



    const handleDateChange = (e) => {

        const { name, value } = e.target;

        if (name === 'fromDate') {

            setFromDate(value);

        } else if (name === 'toDate') {

            setToDate(value);

        }

    };



    const handlePerPageChange = (e) => {

        setPerPage(Number(e.target.value));

    };



    const handlePrevious = () => {

        if (page > 0) {

            setPage(page - 1);

        }

    };



    const handleNext = () => {

        setPage(page + 1);

    };



    const handleSearchChange = (e) => {

        setSearch(e.target.value);

    };



    const handleSubmit = (e) => {

        e.preventDefault();

        setPage(0);

        fetchData();

        setOpenSidebar(false);

    };

    const clearForm = () => {

        setSelectedBrand(null);

        setSelectedState(null);

        setSelectedSource("");

        setSearch("");

        setPage(0);

        fetchData();

    };

 
    const handleFinanceRowSelect = (id, checked) => {
        const numericId = Number(id);
        if (!Number.isInteger(numericId) || numericId <= 0) return;
        setSelectedFinanceIds(prev => checked
            ? [...new Set([...prev, numericId])]
            : prev.filter(value => value !== numericId));
    };

    const handleFinanceSelectAll = checked => {
        const visibleIds = data.map(row => Number(row.id))
            .filter(id => Number.isInteger(id) && id > 0);
        setSelectedFinanceIds(prev => checked
            ? [...new Set([...prev, ...visibleIds])]
            : prev.filter(id => !visibleIds.includes(id)));
    };

    const handleOpenFinanceDialog = () => {
        if (!selectedFinanceIds.length) return;
        setFinanceError('');
        setFinanceFilters({
            client_name: 'Tyger',
            state_id: selectedState?.id ?? '',
            start_date: fromDate,
            end_date: toDate
        });
        setFinanceDialogOpen(true);
    };

    const handleFinanceFilterChange = event => {
        const { name, value } = event.target;
        setFinanceFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmitFinance = async () => {
        if (financeSubmitting || !selectedFinanceIds.length) return;
        if (!financeFilters.start_date || !financeFilters.end_date ||
            financeFilters.start_date > financeFilters.end_date) {
            setFinanceError('Please provide a valid start and end date.');
            return;
        }
    const payload = {
            move_type: 1,
            client_name: financeFilters.client_name,
            state_id: financeFilters.state_id === ''
                ? null
                : Number(financeFilters.state_id),
            start_date: financeFilters.start_date,
            end_date: financeFilters.end_date,
            move_from: "suppliers_leads",
            id_selected: selectedFinanceIds.map(id => ({ id }))
        };
        setFinanceSubmitting(true);
        setFinanceError('');
        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/move-finance-enquiries`,
                payload,
                { headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `${token}`,
                    'adminId': `${adminId}`,
                    'userLevel': `${userLevel}`
                }}
            );
            const body = response.data;
            if (body?.success === false || body?.status === false || body?.status === 'fail') {
                throw new Error(Array.isArray(body?.message) ? body.message.join(', ') : body?.message || 'Finance enquiry transfer failed.');
            }
            setSelectedFinanceIds([]);
            setFinanceDialogOpen(false);
            setSnackbarMessage('Finance enquiry request processed successfully.');
            setSnackbarOpen(true);
            await fetchData();
        } catch (err) {
            const message = err.response?.data?.message || err.message || 'Unable to move finance enquiries.';
            setFinanceError(typeof message === 'string' ? message : JSON.stringify(message));
        } finally {
            setFinanceSubmitting(false);
        }
    };

   const columns = [
        {
            name: 'finance_select',
            label: 'Select',
            options: {
                filter: false,
                sort: false,
                download: false,
                customHeadLabelRender: () => (
                    <Checkbox
                        color="primary"
                        inputProps={{ 'aria-label': 'Select all visible supplied enquiries' }}
                        checked={data.length > 0 && data.every(row => selectedFinanceIds.includes(Number(row.id)))}
                        indeterminate={data.some(row => selectedFinanceIds.includes(Number(row.id))) && !data.every(row => selectedFinanceIds.includes(Number(row.id)))}
                        onChange={event => handleFinanceSelectAll(event.target.checked)}
                    />
                ),
                customBodyRenderLite: dataIndex => {
                    const row = data[dataIndex];
                    if (!row) return null;
                    return <Checkbox
                        color="primary"
                        checked={selectedFinanceIds.includes(Number(row.id))}
                        onChange={event => handleFinanceRowSelect(row.id, event.target.checked)}
                        inputProps={{ 'aria-label': `Select supplied enquiry ${row.id}` }}
                    />;
                }
            }
        },

        {

            name: 'id',

            label: 'S/N',

            options: {

                filter: true,

                setCellProps: () => ({

                    align: "center",

                }),



            },

        },

        {

            name: 'created_at', options: {

                filter: true,

                setCellProps: () => ({

                    align: "left",

                })

            },

            label: "Date",

        },



        {

            name: "brand_name",

            label: "Brand",

            options: {

                filter: false,

                customBodyRender: (value, tableMeta, updateValue) => (

                    <button

                        className={classes.brandstrip}



                        style={{

                            backgroundColor: getColor(value),

                            color: getColorfont(value),

                        }}

                    >

                        {value}

                    </button>

                ),

            },

        },

        {

            name: "modelName",

            label: "Model ",

        },



        {

            name: "fullName",

            label: "User ",

        },

        {

            name: "mobile",

            label: "Mobile  ",

        },



        {

            name: "state_name",

            label: "State  ",

        },

        {

            name: "city_name",

            label: "City",

        },

        {

            name: "taluka",

            label: "Taluka  ",

        },

        {

            name: "pincode",

            label: "Pinecode  ",

        },

        {

            name: "enquiry_from",

            label: "Source  ",

        },



        {

            name: "status",

            label: "status",

            options: {

                filter: false,

                customBodyRender: (value, tableMeta, updateValue) => (

                    <button

                        className={classes.brandstrip}

                        style={{

                            backgroundColor: getColor(value),

                            color: getColorfont(value),

                            width: "100%",

                            minWidth: "140px",

                        }}

                    >

                        {value}

                    </button>

                ),

            },

        },

        {

            name: "view",

            label: "Action",

            options: {

                filter: false,

                sort: false,

                download: false,

                customBodyRender: (value, tableMeta) => {

                    const record = data[tableMeta.rowIndex];



                    return (

                        <Button

                            variant="outlined"

                            color="primary"

                            size="small"

                            onClick={() => handleView(record)}

                        >

                            View

                        </Button>

                    );

                },

            },

        },



    ];

    const CustomToolbarAction = ({ toggleFilter }) => (

        <IconButton aria-label="Filter list" onClick={toggleFilter}>

            <FilterListIcon onClick={toggleSidebar} />

        </IconButton>

    );



    useEffect(() => {

        const handleKeyPress = (event) => {

            if (event.shiftKey && event.key === 'F') {

                setOpenSidebar(true);

            }

        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {

            window.removeEventListener('keydown', handleKeyPress);

        };

    }, []);



    const toggleSidebar = () => {

        setOpenSidebar(!openSidebar);

    };

    const options = {

        rowsPerPage: perPage,

        selectableRows: 'none',

        page: page,

        serverSide: true,

        count: totalCount,

        onTableChange: (action, tableState) => {

            switch (action) {

                case 'changePage':

                    setPage(tableState.page);

                    break;

                case 'changeRowsPerPage':

                    setPerPage(tableState.rowsPerPage);

                    setPage(0);

                    break;

                default:

                    break;

            }

        },



        customToolbar: () => <CustomToolbarAction />,

        filter: false,

        filterType: "dropdown",

        responsive: "standard",

        fixedHeader: true,

        fixedSelectColumn: true,

        overflowy: "auto",

        overflowx: "auto",

        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],

        customFilterDialogFooter: (currentFilter, applyNewFilter) => (

            <div>

                <TextField

                    label="Filter Data"

                    value={filterText}

                    onChange={(e) => setFilterText(e.target.value)}

                    fullWidth

                />

                <Button onClick={applyNewFilter} variant="contained" color="primary">

                    Apply Filter

                </Button>

                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">

                    Cancel

                </Button>

            </div>

        ),



    };

    const currentTheme = customTheme(true);

    const classes = useStyles();

    const memoizedData = useMemo(() => data, [data]);

    const handleCloseSnackbar = (event, reason) => {

        if (reason === 'clickaway') {

            return;

        }

        setSnackbarOpen(false);

    };



    return (

        <>

            <div>

                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>

                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>

                        {snackbarMessage}

                    </MuiAlert>

                </Snackbar>

            </div>

            <Box sx={{ width: '100%' }}>

                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>

                    Supplied

                </Typography>

 
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!selectedFinanceIds.length}
                    onClick={handleOpenFinanceDialog}
                    style={{ float: 'right', marginBottom: 8 }}
                >
                    Move to Finance Enquiry ({selectedFinanceIds.length})
                </Button>
               <hr className={classes.horizontalline} />

            </Box>



            <MuiThemeProvider theme={currentTheme}>

                {

                    isLoading ? (

                        <LinearProgress />



                    ) : (

                        ""

                    )

                }



                <MUIDataTable

                    title={

                        isLoading ? (

                            <Skeleton animation="wave" />



                        ) : (

                            <Typography className={classes.tabletittle} >

                                Supplied

                            </Typography>

                        )

                    }

                    data={memoizedData}

                    columns={columns}

                    options={options}

                />



            </MuiThemeProvider>

            
            <Dialog
                open={financeDialogOpen}
                onClose={() => { if (!financeSubmitting) setFinanceDialogOpen(false); }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Move to Finance Enquiry</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>Selected Supplied Enquiries: {selectedFinanceIds.length}</Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <TextField select fullWidth variant="outlined" label="Client Name"
                                name="client_name" value={financeFilters.client_name}
                                onChange={handleFinanceFilterChange}>
                                <MenuItem value="Tyger">Tyger</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField select fullWidth variant="outlined" label="State"
                                name="state_id" value={financeFilters.state_id}
                                onChange={handleFinanceFilterChange}>
                                <MenuItem value="">All States</MenuItem>
                                {stateOptions.map(item => (
                                    <MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth type="date" variant="outlined" label="Start Date"
                                name="start_date" value={financeFilters.start_date}
                                onChange={handleFinanceFilterChange}
                                InputLabelProps={{ shrink: true }} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField fullWidth type="date" variant="outlined" label="End Date"
                                name="end_date" value={financeFilters.end_date}
                                onChange={handleFinanceFilterChange}
                                InputLabelProps={{ shrink: true }} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth variant="outlined" label="Move From"
                                value="suppliers_leads" disabled />
                        </Grid>
                        {financeError && <Grid item xs={12}>
                            <Typography color="error">{financeError}</Typography>
                        </Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={financeSubmitting} onClick={() => setFinanceDialogOpen(false)}>Cancel</Button>
                    <Button color="primary" variant="contained"
                        disabled={financeSubmitting || !selectedFinanceIds.length}
                        onClick={handleSubmitFinance}>
                        {financeSubmitting ? 'Submitting...' : 'Submit to Finance'}
                    </Button>
                </DialogActions>
            </Dialog>

<Dialog

                open={viewOpen}

                onClose={handleCloseView}

                fullWidth

                maxWidth="md"

            >

                <DialogTitle>

                    Supplied Enquiry Details

                    <IconButton

                        onClick={handleCloseView}

                        style={{

                            position: "absolute",

                            right: 10,

                            top: 8

                        }}

                    >

                        <ClearIcon />

                    </IconButton>

                </DialogTitle>



                <DialogContent dividers>

                    {selectedRecord && (

                        <Grid container spacing={2}>

                            {[

                                ["Enquiry ID", selectedRecord.id],

                                ["Date", selectedRecord.created_at],

                                ["Brand", selectedRecord.brand_name],

                                ["Model", selectedRecord.modelName],

                                ["Customer Name", selectedRecord.fullName],

                                ["Mobile", selectedRecord.mobile],

                                ["State", selectedRecord.state_name],

                                ["City", selectedRecord.city_name],

                                ["Taluka", selectedRecord.taluka],

                                ["Pincode", selectedRecord.pincode],

                                ["Source", selectedRecord.enquiry_from],

                                ["Status", selectedRecord.status],

                                ["Executive", selectedRecord.executive],

                                ["Supplied At", selectedRecord.supplied_at]

                            ].map(([label, value]) => (

                                <Grid item xs={12} sm={6} key={label}>

                                    <Typography

                                        variant="subtitle2"

                                        style={{ fontWeight: 600 }}

                                    >

                                        {label}

                                    </Typography>

                                    <Typography variant="body2">

                                        {value ?? "-"}

                                    </Typography>

                                </Grid>

                            ))}

                        </Grid>

                    )}

                </DialogContent>



                <DialogActions>

                    <Button

                        onClick={handleCloseView}

                        variant="contained"

                        color="primary"

                    >

                        Close

                    </Button>

                </DialogActions>

            </Dialog>



            <Drawer anchor="right" open={openSidebar}

                PaperProps={{

                    style: {

                        width: "100%",

                        maxWidth: 300,

                        padding: "10px"

                    }

                }}

                onClose={() => setOpenSidebar(false)}

            >

                <form onSubmit={handleSubmit}>

                    <Grid container spacing={1}>

                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>

                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />

                        </Grid>

                        <Grid item xs={4} sm={2} lg={12} >

                            <br />

                            <Typography className={classes.tabletittle} >

                                Filter

                            </Typography>

                        </Grid>

                    </Grid>

                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>

                        <div className={classes.root}>

                            <Grid container spacing={1}>

                                <Grid item xs={12} sm={12} lg={12} >

                                    <select

                                        className={classes.inputform}

                                        id="executiveSelect"

                                        value={selectedExecutiveId}

                                        onChange={handleExecutiveChange}

                                    >

                                        <option value="">Select Executive</option>

                                        {executiveOptions.map(option => (

                                            <option key={option.id} value={option.id}>

                                                {option.title}

                                            </option>

                                        ))}

                                    </select>



                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} >

                                    <select

                                        className={classes.inputform}

                                        id="sourceSelect"

                                        value={selectedSource}

                                        onChange={handleSelectChange}

                                    >

                                        <option value="">Select Source</option>

                                        {sources.map((source, index) => (

                                            <option key={index} value={source}>{source}</option>

                                        ))}

                                    </select>

                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} >

                                    <Autocomplete

                                        classes={{

                                            option: classes.autocompleteoption,

                                        }}

                                        options={stateOptions}

                                        getOptionLabel={(option) => option.title}

                                        renderInput={(params) => (

                                            <TextField {...params} placeholder='Select State' variant="outlined" />

                                        )}

                                        value={selectedState}

                                        onChange={handleStateChange}

                                        disableCloseOnSelect

                                        isOptionEqualToValue={(option, value) => option.id === value.id}

                                        getOptionSelected={(option, value) => option.id === value.id}

                                        renderOption={(props, option, { selected }) => (

                                            <li {...props}>

                                                {option.title}

                                            </li>

                                        )}

                                    />





                                </Grid>

                                <Grid item xs={12} sm={12} lg={12} >

                                    <Autocomplete

                                        classes={{

                                            option: classes.autocompleteoption,

                                        }}

                                        options={brandOptions}

                                        getOptionLabel={(option) => option.title}

                                        renderInput={(params) => (

                                            <TextField {...params} placeholder='Select brand' variant="outlined" />

                                        )}

                                        value={selectedBrand}

                                        onChange={handleBrandChange}

                                        disableCloseOnSelect

                                        isOptionEqualToValue={(option, value) => option.id === value.id}

                                        getOptionSelected={(option, value) => option.id === value.id}

                                        renderOption={(props, option, { selected }) => (

                                            <li {...props}>

                                                {option.title}

                                            </li>

                                        )}

                                    />

                                </Grid>

                                <Grid item xs={4} sm={2} lg={12} >

                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />



                                </Grid>



                                <Grid item xs={4} sm={2} lg={12}>

                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />

                                </Grid>

                            </Grid>

                        </div>

                    </div>

                    <br />

                    <Grid >

                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>

                            <Button

                                type='submit'

                                style={{ marginRight: "10px" }}

                                className={classes.buttonform}

                                variant="outlined" startIcon={<ApprovalIcon />}>

                                Apply

                            </Button>

                            <Button

                                type="button" onClick={clearForm}

                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}

                                className={classes.buttonform}

                                variant="outlined" startIcon={<ClearIcon />}>

                                Clear

                            </Button>

                        </Grid>

                    </Grid>

                    <br />

                </form>

            </Drawer >



        </>

    );

};

export default QuotationBookReport;